import { render, staticRenderFns } from "./RandomPaper.vue?vue&type=template&id=403a4f66&scoped=true"
import script from "./RandomPaper.vue?vue&type=script&lang=js"
export * from "./RandomPaper.vue?vue&type=script&lang=js"
import style0 from "./RandomPaper.vue?vue&type=style&index=0&id=403a4f66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403a4f66",
  null
  
)

export default component.exports